import type React from 'react';
import { Page, Layout, Card, Box, Divider, SkeletonBodyText, SkeletonDisplayText, InlineStack, BlockStack } from '@shopify/polaris';
import styles from './Skeleton.module.scss';

/**
 * 首页骨架屏组件
 * 模拟首页的布局结构，在页面加载时显示
 */
const HomeSkeleton: React.FC = () => {
  return (
    <Page
      title="Loading..."
      subtitle="Please wait while we load your content"
    >
      <Layout>
        <Layout.Section>
          <Box paddingBlockEnd="400">
            <Card>
              <Box padding="400">
                <SkeletonBodyText lines={1} />
              </Box>
            </Card>
          </Box>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <Box padding="400">
              <InlineStack align="space-between">
                <SkeletonDisplayText size="small" />
                <span className={styles.iconSkeleton} />
              </InlineStack>
              
              <Box paddingBlock="400">
                <InlineStack align="space-between">
                  <SkeletonBodyText lines={1} />
                  <span className={styles.progressBar} />
                </InlineStack>
              </Box>
              
              <Divider />
              
              {/* 模拟步骤列表 */}
              {[1, 2].map((item) => {
                return (
                  <Box key={item} paddingBlock="400">
                    <BlockStack gap="400">
                      <InlineStack gap="300" align="start">
                        <span className={styles.iconCircle} />
                        <SkeletonBodyText lines={1} />
                      </InlineStack>
                      
                      <Box paddingBlockStart="400">
                        <InlineStack gap="500" align="space-between">
                          <BlockStack gap="400">
                            <SkeletonBodyText lines={2} />
                            <span className={styles.buttonSkeleton} />
                          </BlockStack>
                          <span className={styles.imageSkeleton} />
                        </InlineStack>
                      </Box>
                    </BlockStack>
                    <Divider />
                  </Box>
                );
              })}
            </Box>
          </Card>
        </Layout.Section>
        
        <Layout.Section>
          <Box paddingBlockStart="400">
            <InlineStack align="center">
              <SkeletonBodyText lines={1} />
            </InlineStack>
          </Box>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default HomeSkeleton; 